import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/styles';
import theme from './theme/theme';
import RegistrarUsuario from './componentes/Seguridad/RegistrarUsuario';
import { Grid, Snackbar } from '@mui/material'; 
import Login from './componentes/Seguridad/LoginUser';
import PerfilUsuario from './componentes/Seguridad/PerfilUsuario';
import AppNavBar from './componentes/navegacion/AppNavBar';
import { obtenerUsuarioActual } from './actions/UsuariosAction';
import { useStateValue } from './contexto/store';
import RutaSegura from './componentes/navegacion/RutaSegura';
import ClientesPrincipal from './componentes/GestionDeClientes/Clientes/ClientesPrincipal';
import PerfilCliente from './componentes/GestionDeClientes/Clientes/PerfilCliente';
import ClienteNuevo from './componentes/GestionDeClientes/Clientes/ClienteNuevo';
import Roles from './componentes/Seguridad/AdministrarRoles/Roles';
import CrearRol from './componentes/Seguridad/AdministrarRoles/CrearRol';
import RolModificar from './componentes/Seguridad/AdministrarRoles/RolModificar';
import PanelUsuarios from './componentes/Seguridad/PanelUsuarios';
import TiposTareasTb from './componentes/Seguridad/CrearTipoTarea/TiposTareasTb';
import NuevoTipoTarea from './componentes/Seguridad/CrearTipoTarea/NuevoTipoTarea';
import ModificarTipoTarea from './componentes/Seguridad/CrearTipoTarea/ModificarTipoTarea';
import TiposCampanasTb from './componentes/Seguridad/CrearTipoCampana/TipoCampanaTb';
import NuevoTipoCampana from './componentes/Seguridad/CrearTipoCampana/NuevoTipoCampana';
import ModificarTipoCampana from './componentes/Seguridad/CrearTipoCampana/ModificarTipoCampana';
import PosiblesClientesPrincipal from './componentes/GestionDeClientes/PosiblesClientes/PosiblesClientesPrincipal';
import NuevoPosibleCliente from './componentes/GestionDeClientes/PosiblesClientes/NuevoPosibleCliente';
import PerfilPosibleCliente from './componentes/GestionDeClientes/PosiblesClientes/PerfilPosibleCliente';
import ContactosPrincipal from './componentes/GestionDeClientes/Contactos/ContactosPrincipal';
import NuevoContacto from './componentes/GestionDeClientes/Contactos/NuevoContacto';
import PerfilContactos from './componentes/GestionDeClientes/Contactos/PerfilContactos';
import BuzonDesugerencias from './componentes/GestionDeClientes/BuzonDeSugerencias/BuzonDeSugerencias';
import Prohibido from './componentes/Genericos/Prohibido';
import Difusiones from './componentes/Notas/Difusiones';
import MisNotas from './componentes/Notas/MisNotas';
import NuevaDifusion from './componentes/Notas/NuevaDifusion';
import NuevaNota from './componentes/Notas/NuevaNota';
import AsignarTareas from './componentes/GestionDeTareas/AsignarTareas/AsignarTareas';
import MisTareas from './componentes/GestionDeTareas/MisTareas/MisTareas.js';
import PanelDeTareas from './componentes/GestionDeTareas/PanelDeTareas/PanelDeTareas';
import CampanasPrincipal from './componentes/Marketing/Campanas/CampanasPrincipal';
import NuevaCampana from './componentes/Marketing/Campanas/NuevaCamapana';
import { PerfilCampana } from './componentes/Marketing/Campanas/PerfilCampana';
import Metricas from './componentes/Marketing/Metricas/Metricas';
import NuevaTarea from './componentes/GestionDeTareas/NuevaTarea';
import PerfilTarea from './componentes/GestionDeTareas/PerfilTarea';
import NotasEnviadas from './componentes/Notas/NotasEnviadas';
import { MisPresupuestos } from './componentes/Presupuestos/PresupuestosAsignados/MisPresupuestos';
import { HistorialDeTareasDePresupuesto } from './componentes/Presupuestos/HistorialDeTareasDePresupuesto';
import NuevoPresupuesto from './componentes/Presupuestos/NuevoPresupuesto';
import PanelFacturasPropias from './componentes/GestionDeCobranzas/MisFacturas/PanelFacturasPropias';
import { PresupuestosGeneral } from './componentes/Presupuestos/PresupuestosGeneral/PresupuestosGeneral';
import NuevaFactura from './componentes/GestionDeCobranzas/MisFacturas/NuevaFactura';
import PanelResumenFacturas from './componentes/GestionDeCobranzas/EstadoDeFacturasACobrar/PanelResumenFacturas';
//import PanelGeneralFacturas from './componentes/GestionDeCobranzas/EstadoDeFacturasACobrar/PanelGeneralFacturas';
import { HistorialDeTareasDeFactura } from './componentes/GestionDeCobranzas/HistorialDeTareasDeFacturas';
import PanelGestionDePosiblesCobros from './componentes/GestionDeCobranzas/GestionarPosibleCobro/PanelGestionPosibleCobro';
import PanelPrincipalPosiblesCobros from './componentes/GestionDeCobranzas/PanelPosiblesCobros/PanelPrincipalPosiblesCobros';
import PanelCobranzasAsignadas from './componentes/GestionDeCobranzas/CobranzasAsignadas/PanelCobranzasAsignadas';
import DarDeBajaFacturas from './componentes/GestionDeCobranzas/DarDeBajaFacturas/DarDeBajaFacturas';
import NotificacionesMobile from './componentes/navegacion/bar/NotificacionesMobile';
import Alerta from './componentes/navegacion/alerta';
import Auditoria from './componentes/Seguridad/Auditoria';
import PanelDeSugerencias from './componentes/GestionDeClientes/BuzonDeSugerencias/PanelDeSugerencias';
import PanelFacturasPendientesDeBaja from './componentes/GestionDeCobranzas/PanelFacturasPendientesDeBaja/PanelFacturasPendientesDeBaja';
import ConfiguracionAlerta from './componentes/Seguridad/ConfigurarAlerta/ConfiguracionAlerta';
import ImportarExcel from './componentes/Seguridad/ImportarExcel';
import GestionUsuario from './componentes/Seguridad/GestionUsuario';
import MainDashboardPanel from './componentes/Dashboard/MainDashboardPanel';
import ReporteDeBugs from './componentes/Seguridad/ReporteDeBugs';
import AsignarExcel from './componentes/Seguridad/AsignarExcel';
import RevertirExcel from './componentes/Seguridad/RevertirExcel';
import PanelPrincipalCorreosMasivos from './componentes/Marketing/CorreosMasivos/PanelPrincipalCorreosMasivos';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import RealizarEncuesta from './componentes/GestionDeEncuestas/RealizarEncuesta'
import MisEncuestas from './componentes/GestionDeEncuestas/MisEncuestas'
import NuevaEncuesta from './componentes/GestionDeEncuestas/NuevaEncuesta'
import VerEncuesta from './componentes/GestionDeEncuestas/VerEncuesta'
import ModificarEncuesta from './componentes/GestionDeEncuestas/ModificarEncuesta'
import RespuestasEncuesta from './componentes/GestionDeEncuestas/RespuestasEncuesta'
import AnaliticasEncuesta from './componentes/GestionDeEncuestas/AnaliticasEncuesta'
import EnviarEncuestaWhatsApp from './componentes/GestionDeEncuestas/EnviarEncuestaWhatsApp'
import FacturasGeneral from './componentes/GestionDeCobranzas/FacturasGeneral'
import EncuestaPublica from './componentes/GestionDeEncuestas/EncuestaPublica'
import useCierrePorInactividad from '././useCierrePorInactividad';
function App() {
  const [{ openSnackBar }, dispatch] = useStateValue();
  const [iniciaApp, setIniciaApp] = useState(false);

  // Cierre automático por inactividad
  useCierrePorInactividad();

  useEffect(() => {
    if (!iniciaApp) {
      obtenerUsuarioActual(dispatch)
        .then((response) => {
          setIniciaApp(true);
        })
        .catch((error) => {
          setIniciaApp(true);
        });
    }
  }, [iniciaApp, dispatch]);

  return iniciaApp === false ? null : (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={openSnackBar ? openSnackBar.open : false}
        autoHideDuration={5000}
        ContentProps={{ 'aria-describedby': 'message-id' }}
        message={
          <span id="message-id">
            {openSnackBar ? openSnackBar.mensaje : ''}
          </span>
        }
        onClose={() =>
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: false,
              mensaje: '',
            },
          })
        }
      ></Snackbar>
      <Router>
        <MuiThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          <Alerta />
          <AppNavBar />
          <Grid container>
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/prohibido" component={Prohibido} />
              <Route exact path="/encuesta/:token" component={EncuestaPublica} />
              <RutaSegura
                exact
                path="/registrar"
                component={RegistrarUsuario}
              />
              <RutaSegura exact path="/perfil" component={PerfilUsuario} />
              <RutaSegura exact path="/" component={MainDashboardPanel} />
              <RutaSegura
                exact
                path="/clientesPrincipal"
                component={ClientesPrincipal}
              />
              <RutaSegura exact path="/clienteNuevo" component={ClienteNuevo} />
              <RutaSegura
                exact
                path="/clientePerfil"
                component={PerfilCliente}
              />
              <RutaSegura exact path="/rol" component={Roles} />
              <RutaSegura exact path="/rol/nuevo" component={CrearRol} />
              <RutaSegura
                exact
                path="/rol/modificar"
                component={RolModificar}
              />
              <RutaSegura
                exact
                path="/usuariosRoles"
                component={PanelUsuarios}
              />
              <RutaSegura exact path="/tipostareas" component={TiposTareasTb} />
              <RutaSegura
                exact
                path="/tipostareas/nuevo"
                component={NuevoTipoTarea}
              />
              <RutaSegura
                exact
                path="/tipostareas/modificar"
                component={ModificarTipoTarea}
              />
              <RutaSegura
                exact
                path="/tiposcampanas"
                component={TiposCampanasTb}
              />
              <RutaSegura
                exact
                path="/tipocampana/nuevo"
                component={NuevoTipoCampana}
              />
              <RutaSegura
                exact
                path="/tipocampana/modificar"
                component={ModificarTipoCampana}
              />
              <RutaSegura
                exact
                path="/posiblesClientesPrincipal"
                component={PosiblesClientesPrincipal}
              />
              <RutaSegura
                exact
                path="/posibleClienteNuevo"
                component={NuevoPosibleCliente}
              />
              <RutaSegura
                exact
                path="/posibleClientePerfil"
                component={PerfilPosibleCliente}
              />
              <RutaSegura
                exact
                path="/contactosPrincipal"
                component={ContactosPrincipal}
              />
              <RutaSegura
                exact
                path="/contactosNuevo"
                component={NuevoContacto}
              />
              <RutaSegura
                exact
                path="/contactosPerfil"
                component={PerfilContactos}
              />
              <RutaSegura
                exact
                path="/buzonSugerencias"
                component={BuzonDesugerencias}
              />
              <RutaSegura exact path="/tareasPrincipal" component={MisTareas} />
              <RutaSegura exact path="/nuevaTarea" component={NuevaTarea} />
              <RutaSegura exact path="/perfilTarea" component={PerfilTarea} />
              <RutaSegura
                exact
                path="/asignarTareas"
                component={AsignarTareas}
              />
              <RutaSegura exact path="/panelTareas" component={PanelDeTareas} />
              <RutaSegura
                exact
                path="/campanasPrincipal"
                component={CampanasPrincipal}
              />
              <RutaSegura exact path="/nuevaCampana" component={NuevaCampana} />
              <RutaSegura
                exact
                path="/modificarCampana"
                component={PerfilCampana}
              />
              <RutaSegura exact path="/difusiones" component={Difusiones} />
              <RutaSegura exact path="/misNotas" component={MisNotas} />
              <RutaSegura
                exact
                path="/nuevaDifusion"
                component={NuevaDifusion}
              />
              <RutaSegura exact path="/nuevaNota" component={NuevaNota} />
              <RutaSegura
                exact
                path="/notasEnviadas"
                component={NotasEnviadas}
              />
              <RutaSegura exact path="/metricas" component={Metricas} />
              <RutaSegura
                exact
                path="/misPresupuestos"
                component={MisPresupuestos}
              />
              <RutaSegura
                exact
                path="/tareasPresupuesto"
                component={HistorialDeTareasDePresupuesto}
              />
              <RutaSegura
                exact
                path="/nuevoPresupuesto"
                component={NuevoPresupuesto}
              />
              <RutaSegura
                exact
                path="/presupuestosGeneral"
                component={PresupuestosGeneral}
              />
              <RutaSegura
                exact
                path="/panelFacturasPropias"
                component={PanelFacturasPropias}
              />
              <RutaSegura exact path="/nuevaFactura" component={NuevaFactura} />
              <RutaSegura
                exact
                path="/panelFacturasResumen"
                component={PanelResumenFacturas}
              />
              <RutaSegura
                exact
                path="/panelFacturasGeneral"
                component={FacturasGeneral}
              />
              <RutaSegura
                exact
                path="/historialTareasFactura"
                component={HistorialDeTareasDeFactura}
              />
              <RutaSegura
                exact
                path="/gestionarPosibleCobro"
                component={PanelGestionDePosiblesCobros}
              />
              <RutaSegura
                exact
                path="/panelPosiblesCobrosPrincipal"
                component={PanelPrincipalPosiblesCobros}
              />
              <RutaSegura
                exact
                path="/cobranzasAsignadas"
                component={PanelCobranzasAsignadas}
              />
              <RutaSegura
                exact
                path="/darDeBajaFacturas"
                component={DarDeBajaFacturas}
              />
              <RutaSegura exact path="/auditoria" component={Auditoria} />
              <RutaSegura
                exact
                path="/panelSugerencias"
                component={PanelDeSugerencias}
              />
              <RutaSegura
                exact
                path="/panelFacturasPendientesDeBaja"
                component={PanelFacturasPendientesDeBaja}
              />
              <RutaSegura
                exact
                path="/configurarAlerta"
                component={ConfiguracionAlerta}
              />
              <RutaSegura
                exact
                path="/importarExcel"
                component={ImportarExcel}
              />
              <RutaSegura
                exact
                path="/gestionRolesUsuarios"
                component={GestionUsuario}
              />
              <RutaSegura
                exact
                path="/asignarExcel"
                component={AsignarExcel}
              />
              <RutaSegura
                exact
                path="/reportarBug"
                component={ReporteDeBugs}
              />
               <RutaSegura
                exact
                path="/panelFacturasGeneral"
                component={FacturasGeneral}
              />
                <RutaSegura
                exact
                path="/revertirExcel"
                component={RevertirExcel}
              />
              <RutaSegura
                exact
                path="/correosMasivos"
                component={PanelPrincipalCorreosMasivos}
              />
               <RutaSegura
                exact
                path="/realizar-encuesta"
                component={RealizarEncuesta}
              />
               <RutaSegura
                exact
                path="/mis-encuestas"
                component={MisEncuestas}
              />
               <RutaSegura
                exact
                path="/nuevaEncuesta"
                component={NuevaEncuesta}
              />
               <RutaSegura
                exact
                path="/ver-encuesta/:encuestaId"
                component={VerEncuesta}
              />
              <RutaSegura
                exact
                path="/modificar-encuesta/:encuestaId"
                component={ModificarEncuesta}
              />
              <RutaSegura
                exact
                path="/respuestas/:encuestaId"
                component={RespuestasEncuesta}
              />
              <RutaSegura
                exact
                path="/analiticas/:encuestaId"
                component={AnaliticasEncuesta}
              />
              <RutaSegura
                exact
                path="/enviar-encuesta-whatsapp"
                component={EnviarEncuestaWhatsApp}
              />
            </Switch> 
          </Grid>
          <NotificacionesMobile />
          </LocalizationProvider>
        </MuiThemeProvider>
      </Router>
      </MuiThemeProvider>
    </React.Fragment>
  );
}

export default App;
